// extracted by mini-css-extract-plugin
var _1 = "LabBlockButton__background--ge4jy";
var _2 = "LabBlockButton__backgroundHover--lSmV1 LabBlockButton__background--ge4jy";
var _3 = "LabBlockButton__blockBeast--YrwZf";
var _4 = "LabBlockButton__blockTitle--BHklO BlockButton__blockTitle--iEl7r fontSize__blockTitle--Od4OD";
var _5 = "LabBlockButton__celestialIcon--tfhVS";
var _6 = "LabBlockButton__comet--uLfhC LabBlockButton__celestialIcon--tfhVS";
var _7 = "LabBlockButton__debugShow--bEVwq";
var _8 = "LabBlockButton__galaxy--Bb3B3 LabBlockButton__celestialIcon--tfhVS";
var _9 = "LabBlockButton__grayscale--LZKwM";
var _a = "LabBlockButton__labBlock--dj5vO";
var _b = "LabBlockButton__labBlockBorder--K_xFq";
var _c = "LabBlockButton__lock--CA3v_ BlockButton__lock--Kpq3y";
var _d = "LabBlockButton__lockIcon--Xze2X";
var _e = "LabBlockButton__locked--Cwu7S";
var _f = "LabBlockButton__main--PfAIE";
var _10 = "LabBlockButton__moon--h13gr LabBlockButton__celestialIcon--tfhVS";
var _11 = "LabBlockButton__planet--fkpAr LabBlockButton__celestialIcon--tfhVS";
var _12 = "LabBlockButton__title--xAhlm";
var _13 = "LabBlockButton__titleContainer--SdAV5";
var _14 = "LabBlockButton__tooltip--JIJqE BlockButton__tooltip--U2IPJ";
var _15 = "LabBlockButton__unfinished--j1F0Q";
export { _1 as "background", _2 as "backgroundHover", _3 as "blockBeast", _4 as "blockTitle", _5 as "celestialIcon", _6 as "comet", _7 as "debugShow", _8 as "galaxy", _9 as "grayscale", _a as "labBlock", _b as "labBlockBorder", _c as "lock", _d as "lockIcon", _e as "locked", _f as "main", _10 as "moon", _11 as "planet", _12 as "title", _13 as "titleContainer", _14 as "tooltip", _15 as "unfinished" }
